/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Box,
  CircularProgress,
  TextField,
  Modal,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  Grid,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Alert
} from '@mui/material';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { Close } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import ClientAction from '../../store/actions/ClientAction';

function ClientImport({ openmodal, onCloseModal }) {
  const dispatch = useDispatch();

  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [formError, setFormError] = useState('');

  const handleDownloadTemplate = () => {
    dispatch(ClientAction.downloadImportTemplate());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError('');

    if (!file) {
      setFormError('Please choose a CSV or Excel file to import.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setSubmitting(true);
    dispatch(ClientAction.importClients(formData, setSubmitting, setResult));
  };

  return (
    <Modal
      variant="temporary"
      anchor="right"
      open={openmodal}
      sx={{
        flexShrink: 0,
        zIndex: 1205
      }}
    >
      <Box className="largeModal">
        <form onSubmit={handleSubmit}>
          <Card>
            <CardHeader
              sx={{ textAlign: 'left !important' }}
              title="Import Clients"
              action={
                <IconButton aria-label="close" onClick={() => onCloseModal()}>
                  <Close />
                </IconButton>
              }
            />
            <CardContent>
              <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Map your data into the template columns and upload. Every field lives in the
                    sheet — Company is matched or created by name, Department, Accept Payment Via
                    and Secondary Email are comma-separated. Only First Name, Last Name, Email,
                    Company, Department and Currency are required per row.
                  </Typography>
                  <Button
                    type="button"
                    variant="text"
                    color="secondary"
                    size="small"
                    startIcon={<DownloadOutlinedIcon fontSize="small" />}
                    onClick={handleDownloadTemplate}
                    sx={{ mb: 2, textTransform: 'none', pl: 0 }}
                  >
                    Download sample template
                  </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="file"
                    name="file"
                    margin="normal"
                    label="Upload File (.csv, .xlsx)"
                    InputLabelProps={{ shrink: true, required: true }}
                    inputProps={{ accept: '.csv,.xlsx,.xls' }}
                    onChange={(e) => {
                      setFile(e.target.files && e.target.files[0] ? e.target.files[0] : null);
                      setResult(null);
                    }}
                  />
                </Grid>

                {formError ? (
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mt: 1 }}>
                      {formError}
                    </Alert>
                  </Grid>
                ) : null}

                {result ? (
                  <Grid item xs={12}>
                    <Alert severity={result.created > 0 ? 'success' : 'warning'} sx={{ mt: 2 }}>
                      Created {result.created}, skipped {result.skipped}.
                    </Alert>
                    {result.errors && result.errors.length > 0 ? (
                      <Box sx={{ mt: 2, maxHeight: 220, overflow: 'auto' }}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: 80 }}>Row</TableCell>
                              <TableCell>Reason</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {result.errors.map((err) => (
                              <TableRow key={`${err.row}-${err.reason}`}>
                                <TableCell>{err.row}</TableCell>
                                <TableCell>{err.reason}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    ) : null}
                  </Grid>
                ) : null}
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center' }}>
              <Button
                type="submit"
                className="save__btn"
                variant="contained"
                color="secondary"
                disabled={submitting}
                size="medium"
              >
                {submitting ? <CircularProgress size={20} /> : 'Import'}
              </Button>
              <Button
                type="button"
                className="cancel__btn"
                variant="contained"
                color="info"
                size="medium"
                onClick={() => onCloseModal()}
              >
                Close
              </Button>
            </CardActions>
          </Card>
        </form>
      </Box>
    </Modal>
  );
}

ClientImport.propTypes = {
  openmodal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ClientImport;
